export type TooltipToastAppearance = {backgroundColor?: string; color?: string};

export default class ToastData {
  text = "";
  tooltipIconUrl: string | undefined;
  tooltipAppearance: TooltipToastAppearance | undefined;
  title: string | undefined;
  isError = false;
  isSuccess = false;
  visible = false;
  modal = false;
  progress = false;
}
